import { Dropdown, NavDropdown } from 'react-bootstrap';
import Bars from '@rss-engineering/fabric-assets/dist/icons/Bars';
import {
  externalLinksNames,
  getExternalLink,
  ACCOUNT_TYPES
} from './constants';

const LinkDropdown = ({ domain, accountType }) => {
  // Filter out Services link for OPENSTACK_ENTERPRISE accounts
  const displayLinks = externalLinksNames.filter((name) => !(name === 'Services' &&
    accountType === ACCOUNT_TYPES.OPENSTACK_ENTERPRISE));

  return (
    <NavDropdown
      title={<Bars size={16} />}
      id="nav-dropdown"
      className="d-inline-block me-3 text-primary"
    >
      <Dropdown.Item disabled>View</Dropdown.Item>
      {displayLinks.map((name) => (
        <Dropdown.Item
          key={name}
          href={getExternalLink(name, domain)}
          target="_blank"
        >
          {name}
        </Dropdown.Item>
      ))}
    </NavDropdown>
  );
};

export default LinkDropdown;
